import React from 'react';
import { filter } from 'lodash';

import { isLoadingStatus } from 'src/presentation/hooks/useResource';

import { Edit } from '../shared/rowActions/Edit';
import ReferencesColumn from './ReferencesColumn';
import RouterLinkButton from 'src/presentation/components/RouterLinkButton';
import TablePage, { TablePageRender } from 'src/presentation/components/pages/shared/TablePage';

// import AudienceDelete from './AudienceDelete';
import AudienceEditor from './AudienceEditor';
import AudiencesEmptyState from './AudiencesEmptyState';
import useFetchAudiences from './hooks/useFetchAudiences';
import { CHAT_BRAND } from 'src/constants/branding';

const dataAidPrefix = 'audiences-';

const columnConfig = [
  { attr: 'name', label: 'Audience', customColumnStyle: () => ({ width: '35%' }) },
  {
    attr: 'audiences.inAnswers',
    label: 'In Answers',
    customRenderer: item => <ReferencesColumn item={item} resourceType="ANSWER" roleFeature="answers:admin" />,
    customColumnStyle: () => ({ width: '145px' }),
  },
  {
    attr: 'audiences.inHelpCenters',
    label: 'In Help Centers',
    customRenderer: item => <ReferencesColumn item={item} resourceType="HELP_CENTER" roleFeature="answers:admin" />,
  },
  {
    attr: 'audiences.inChats',
    label: `In ${CHAT_BRAND.plural}`,
    customRenderer: item => (
      <ReferencesColumn item={item} resourceType="CHAT" roleFeature="sidekickConfigurationManagement" />
    ),
  },
  { attr: 'updatedAt', label: 'Last Modified On' },
  { attr: 'updatedBy', label: 'Last Modified By' },
];

function renderRowActions({ item }) {
  return (
    <>
      <Edit id={item.id} />
      {/* <AudienceDelete item={item} /> */}
      {/* We're disabling delete until it's ready on the backend */}
    </>
  );
}

const Audiences: TablePageRender = ({ root }) => {
  const { audiences, errors, loadingState, resetErrors } = useFetchAudiences();
  function filterFunc(items, searchString) {
    if (!searchString) {
      return items;
    }
    const results = filter(items, item => {
      return item.name.toLowerCase().indexOf(searchString.toLowerCase()) > -1;
    });
    return results;
  }

  const actions = (
    <RouterLinkButton data-aid={`${dataAidPrefix}addNew`} to={`${root}/new`}>
      Create Audience
    </RouterLinkButton>
  );

  const description = (
    <span>
      Audiences categorize Answers into groups like business lines, brands, or regions. Once added, they can&apos;t be
      deleted since they&apos;re used for reporting and other settings. Learn more about managing Audiences in our{' '}
      <a href="https://help.gladly.com/docs/create-and-edit-audiences-1" target="_blank" rel="noreferrer">
        Help Docs
      </a>
      .
    </span>
  );

  return (
    <TablePage
      actions={actions}
      columnConfig={columnConfig}
      description={description}
      editor={AudienceEditor}
      emptyStateRender={<AudiencesEmptyState actions={actions} />}
      errors={errors}
      filterFunc={filterFunc}
      isLoading={isLoadingStatus(loadingState)}
      items={audiences}
      name="Audiences"
      resetErrors={resetErrors}
      root={root}
      renderRowActions={renderRowActions}
      data-aid={`${dataAidPrefix}page`}
    />
  );
};

export default Audiences;
